<template>
  <div>
    <h1>Novo pauta</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("pautas", ["pauta"]),
  },
  methods: {
    ...mapActions("pautas", ["ActionNewpauta"]),
    loadData(id) {
      this.$router.push({ name: "pautas_edit", params: { id: id } });
    },
  },
  async created() {
    await this.ActionNewpauta();
  },
};
</script>

<style></style>
